import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingButtons from './components/FloatingButtons';
import AnnouncementBanner from './components/AnnouncementBanner';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ResumePage from './pages/ResumePage';
import ProjectsPage from './pages/ProjectsPage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Checkout from './pages/Checkout';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';
import ClientDashboard from './pages/ClientDashboard';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnnouncementBanner />
        <ToastContainer position="top-right" theme="dark" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/dashboard/*" element={<ClientDashboard />} />
          <Route path="/admin/login" element={<Login adminMode />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
        <FloatingButtons />
      </Router>
    </AuthProvider>
  );
}

export default App;
